(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScriptsTypesDialogController', ScriptsTypesDialogController);

    ScriptsTypesDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'ScriptsTypes', '$state'];

    function ScriptsTypesDialogController ($timeout, $scope, $stateParams, entity, ScriptsTypes, $state) {
        var vm = this;
        vm.scriptsTypes = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:scriptsTypesUpdate', result);
            vm.isSaving = false;
            $state.go('scripts-types');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.scriptsTypes.id !== null) {
                ScriptsTypes.update(vm.scriptsTypes, onSaveSuccess, onSaveError);
            } else {
                ScriptsTypes.save(vm.scriptsTypes, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $state.go('scripts-types');
        };
    }
})();
